import React from 'react';

/**
 * Componente de link externo con ícono
 * @param {string} href - URL del enlace externo
 * @param {string} text - Texto del enlace (por defecto "Leer más")
 */
const ExternalLink = ({ href, text = "Leer más" }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="external-link"
    >
      <span className="external-link-text">{text}</span>
      <svg
        className="external-link-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 5V19M5 12H19"
          stroke="#F7C946"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </a>
  );
};

export default ExternalLink;
